export const simraUrl =
  'http://207.180.205.80/map?lat=52.35248555312976&lng=13.631286621093752&z=13&style=CARTO_POSITRON&m=1&sm=0';

export const notionUrl =
  'https://nudafa.notion.site/Teilprojekte-76892769f8244a63a044ac75e210d873';

export const radnetzplanungPath = '/radnetzplanung#radverkehrsatlas';
